import { useState, useEffect } from "react"
import { statsService, DashboardStats } from "../../../services/statsService"

export const useStats = () => {
  const [stats, setStats] = useState<DashboardStats>({
    total_farmers: 0,
    total_trees: 0,
    total_tree_types: 0,
    active_regions: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const statsData = await statsService.getDashboardStats()
        setStats(statsData)
      } catch (error) {
        console.error("Failed to fetch stats:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [])

  return { stats, loading }
}
